import React, { useState, useMemo } from "react";

const FONT_LINK_ID = "guia-fonts";

const C = {
  bg: "#ffffff",
  ink: "#2C3E4E",
  inkSoft: "#647686",
  green: "#63B887",
  greenSoft: "#eaf6ef",
  line: "#e6eaee",
  lineSoft: "#f1f4f6",
};

const CATEGORIES = [
  {
    id: "pagamentos",
    label: "Pagamentos e Boletos",
    num: "01",
    items: [
      {
        q: "Quero alterar a forma de pagamento das mensalidades. Como proceder?",
        a: "A alteração da forma de pagamento está disponível para alunos de edições a partir de 2024/2 e pode ser realizada mediante solicitação via suporte.",
      },
      {
        q: "Como emitir ou baixar meus boletos pela plataforma?",
        a: "Acesse a Área do Participante e localize a aba de pagamentos para visualizar, emitir ou realizar o download dos boletos disponíveis.",
      },
      {
        q: "Meu boleto venceu. Como posso atualizá-lo?",
        a: "Boletos vencidos há até 60 dias podem ser atualizados diretamente na plataforma pelo próprio aluno. Após 60 dias de vencimento, será necessário solicitar o boleto atualizado pelo e-mail especializacoes@fundmed.org.br.",
      },
      {
        q: "Já realizei o pagamento, mas ele ainda aparece em aberto. O que fazer?",
        a: "Pagamentos via cartão de crédito ou PIX podem levar até 24 horas úteis para compensação. Pagamentos via boleto podem levar até 72 horas úteis. Caso identifique alguma divergência após esse período, envie o comprovante de pagamento para especializacoes@fundmed.org.br.",
      },
      {
        q: "O que acontece em caso de atraso no pagamento?",
        a: "Conforme previsto em contrato, pagamentos realizados após o vencimento estão sujeitos à incidência de multa, juros e correção monetária. Em casos de atraso superior a 90 dias, poderão ser adotadas medidas administrativas e jurídicas previstas contratualmente.",
      },
    ],
  },
  {
    id: "recorrente",
    label: "Crédito Recorrente",
    num: "02",
    items: [
      {
        q: "Como funciona o pagamento em crédito recorrente?",
        a: "O crédito recorrente é uma modalidade de cobrança automática no cartão de crédito, em que as parcelas são cobradas mensalmente conforme o vencimento previsto (dia 20 de cada mês), sem comprometer o limite total do cartão de uma única vez. É importante manter limite disponível no cartão na data do vencimento para que a cobrança seja autorizada corretamente.",
      },
      {
        q: "Como alterar o cartão de crédito cadastrado?",
        a: "O aluno poderá acessar a Área do Participante e realizar a alteração do cartão cadastrado diretamente pela plataforma.",
      },
      {
        q: "Posso cadastrar um novo cartão mesmo sem existir fatura vencida?",
        a: "Sim. O cadastro de um novo cartão pode ser realizado a qualquer momento diretamente na plataforma, na aba de pagamentos, mesmo sem existir mensalidade vencida.",
      },
      {
        q: "Minha cobrança recorrente não foi autorizada. O que devo fazer?",
        a: "Primeiramente, recomendamos verificar junto ao banco ou administradora do cartão o motivo da recusa. Após regularizar a situação ou cadastrar um novo cartão, será necessário acessar a plataforma, na aba de pagamentos, e clicar em “Efetuar compra” para realizar novamente a tentativa de cobrança.",
      },
      {
        q: "Não havia limite disponível no cartão na data do vencimento. O que devo fazer agora?",
        a: "Após regularizar o limite do cartão, acesse a plataforma na aba de pagamentos e clique em “Efetuar compra” para realizar novamente a cobrança da mensalidade.",
      },
      {
        q: "Como cadastrar um novo cartão quando a cobrança recorrente não é autorizada?",
        a: "Acesse a Área do Participante, realize o cadastro de um novo cartão de crédito e, após a atualização, clique em “Efetuar compra” para processar novamente a cobrança.",
      },
      {
        q: "Posso alterar a data de vencimento das mensalidades?",
        a: "O vencimento padrão das mensalidades é sempre no dia 20 de cada mês, não sendo possível sua alteração.",
      },
    ],
  },
  {
    id: "academico",
    label: "Cancelamento e Questões Acadêmicas",
    num: "03",
    items: [
      {
        q: "Como solicitar o cancelamento do curso?",
        a: "O estudante deve entrar em contato com a Coordenação do Curso e com o setor de Pós-Graduação do HCPA (DENS).",
      },
      {
        q: "É possível solicitar trancamento do curso?",
        a: "Não há possibilidade de trancamento, considerando que os cursos não possuem previsão de continuidade imediata de turmas/projetos.",
      },
      {
        q: "Tenho dúvidas acadêmicas ou pedagógicas. Com quem devo falar?",
        a: "Para dúvidas relacionadas a atestado de matrícula, cronograma de aulas, justificativa de faltas, documentos acadêmicos e demais orientações pedagógicas, contate o Setor de Pós-Graduação DENS — 6º andar do Bloco C, Sala 6168. E-mail: posgraduacao@hcpa.edu.br · WhatsApp: (51) 3359-6259.",
      },
    ],
  },
  {
    id: "documentos",
    label: "Documentos Financeiros",
    num: "04",
    items: [
      {
        q: "Como solicitar o Informe de Rendimentos?",
        a: "O Informe de Rendimentos fica disponível diretamente na plataforma, na aba de pagamentos, sempre referente ao ano anterior para fins de Imposto de Renda.",
      },
    ],
  },
];

 

function renderRich(text) {
  const parts = text.split(/(\b[\w.+-]+@[\w-]+\.[\w.-]+\b|\(\d{2}\)\s?\d{4}-\d{4})/g);
  return parts.map((p, i) => {
    if (/@/.test(p)) {
      return (
        <a key={i} href={`mailto:${p}`} style={{ color: C.green, fontWeight: 600, textDecoration: "none" }}>
          {p}
        </a>
      );
    }
    if (/\(\d{2}\)/.test(p)) {
      const digits = p.replace(/\D/g, "");
      return (
        <a key={i} href={`https://wa.me/55${digits}`} target="_blank" rel="noreferrer" style={{ color: C.green, fontWeight: 600, textDecoration: "none" }}>
          {p}
        </a>
      );
    }
    return <span key={i}>{p}</span>;
  });
}

function AccordionItem({ item, index, openKey, setOpenKey, itemKey }) {
  const isOpen = openKey === itemKey;
  return (
    <div
      style={{
        border: `1px solid ${isOpen ? C.green : C.line}`,
        borderRadius: "12px",
        marginBottom: "0.65rem",
        background: C.bg,
        transition: "border-color 0.3s ease, box-shadow 0.3s ease",
        boxShadow: isOpen ? "0 6px 22px rgba(44,62,78,0.07)" : "none",
        overflow: "hidden",
      }}
    >
      <button
        onClick={() => setOpenKey(isOpen ? null : itemKey)}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "0.9rem",
          padding: "1.15rem 1.25rem",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
          font: "inherit",
        }}
      >
        <span
          style={{
            fontSize: "0.72rem",
            fontWeight: 700,
            color: isOpen ? C.green : C.inkSoft,
            minWidth: "1.4rem",
            transition: "color 0.3s",
          }}
        >
          {String(index + 1).padStart(2, "0")}
        </span>
        <span style={{ flex: 1, fontSize: "1rem", fontWeight: 600, lineHeight: 1.4, color: C.ink }}>
          {item.q}
        </span>
        <span
          aria-hidden
          style={{
            width: "26px",
            height: "26px",
            flexShrink: 0,
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            background: isOpen ? C.green : C.lineSoft,
            color: isOpen ? "#fff" : C.inkSoft,
            fontSize: "1.1rem",
            lineHeight: 1,
            transition: "transform 0.35s cubic-bezier(.4,0,.2,1), background 0.3s",
            transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
          }}
        >
          +
        </span>
      </button>
      <div
        style={{
          maxHeight: isOpen ? "440px" : "0px",
          overflow: "hidden",
          transition: "max-height 0.4s cubic-bezier(.4,0,.2,1)",
        }}
      >
        <p
          style={{
            margin: 0,
            padding: "0 1.25rem 1.3rem 3.55rem",
            fontSize: "0.95rem",
            lineHeight: 1.65,
            color: C.inkSoft,
          }}
        >
          {renderRich(item.a)}
        </p>
      </div>
    </div>
  );
}

export default function GuiaEstudantes() {
 
  const [openKey, setOpenKey] = useState(null);
  const [query, setQuery] = useState("");
  const [activeCat, setActiveCat] = useState("todos");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return CATEGORIES.map((cat) => {
      const items = cat.items.filter((it) => {
        const matchCat = activeCat === "todos" || activeCat === cat.id;
        const matchQuery = !q || it.q.toLowerCase().includes(q) || it.a.toLowerCase().includes(q);
        return matchCat && matchQuery;
      });
      return { ...cat, items };
    }).filter((cat) => cat.items.length > 0);
  }, [query, activeCat]);

  const totalShown = filtered.reduce((n, c) => n + c.items.length, 0);

  return (
    <div
      style={{
        width: '100%',
        minHeight: "100vh",
        background: C.bg,
         
        color: C.ink,
        padding: "3.5rem 1.25rem 4rem",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        {/* Header */}
        <header style={{ marginBottom: "2.2rem" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "0.35rem 0.8rem",
              borderRadius: "100px",
              background: C.greenSoft,
              fontSize: "0.72rem",
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: C.green,
              marginBottom: "1.3rem",
            }}
          >
            <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: C.green }} />
            Cursos de Especialização
          </div>
          <h1
            style={{
              fontWeight: 800,
              fontSize: "clamp(2rem, 5.5vw, 2.9rem)",
              lineHeight: 1.1,
              margin: "0 0 0.9rem",
              letterSpacing: "-0.02em",
            }}
          >
            Guia Rápido dos Estudantes
          </h1>
          <p style={{ fontSize: "1.02rem", lineHeight: 1.6, color: C.inkSoft, maxWidth: "56ch", margin: 0 }}>
            Principais dúvidas sobre acesso à plataforma, pagamentos e procedimentos
            acadêmicos e financeiros. Toque em uma pergunta para ver a orientação.
          </p>
        </header>

        {/* Search */}
        <div style={{ position: "relative", marginBottom: "1.1rem" }}>
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Buscar uma dúvida…"
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "0.9rem 1rem 0.9rem 2.6rem",
            
              fontSize: "0.98rem",
              color: C.ink,
              background: C.bg,
              border: `1px solid ${C.line}`,
              borderRadius: "10px",
              outline: "none",
            }}
            onFocus={(e) => (e.target.style.borderColor = C.green)}
            onBlur={(e) => (e.target.style.borderColor = C.line)}
          />
          <span style={{ position: "absolute", left: "0.95rem", top: "50%", transform: "translateY(-50%)", color: C.inkSoft, fontSize: "1.05rem" }} aria-hidden>
            ⌕
          </span>
        </div>

        {/* Category filter */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.45rem", marginBottom: "2rem" }}>
          {[{ id: "todos", label: "Todas" }, ...CATEGORIES].map((cat) => {
            const active = activeCat === cat.id;
            return (
              <button
                key={cat.id}
                onClick={() => setActiveCat(cat.id)}
                style={{
                  
                  fontSize: "0.82rem",
                  fontWeight: 600,
                  padding: "0.45rem 0.95rem",
                  borderRadius: "100px",
                  cursor: "pointer",
                  border: `1px solid ${active ? C.green : C.line}`,
                  background: active ? C.green : C.bg,
                  color: active ? "#fff" : C.inkSoft,
                  transition: "all 0.2s",
                }}
              >
                {cat.label}
              </button>
            );
          })}
        </div>

        {/* Accordion */}
        {totalShown === 0 ? (
          <p style={{ textAlign: "center", color: C.inkSoft, padding: "3rem 0" }}>
            Nenhuma dúvida encontrada para “{query}”.
          </p>
        ) : (
          filtered.map((cat) => (
            <section key={cat.id} style={{ marginBottom: "2.2rem" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", marginBottom: "0.9rem" }}>
                <h2 style={{ fontWeight: 700, fontSize: "0.78rem", letterSpacing: "0.1em", textTransform: "uppercase", color: C.ink, margin: 0 }}>
                  {cat.label}
                </h2>
                <span style={{ flex: 1, height: "1px", background: C.line }} />
                <span style={{ fontSize: "0.72rem", fontWeight: 700, color: C.green }}>{cat.num}</span>
              </div>
              {cat.items.map((item, i) => {
                const itemKey = `${cat.id}-${i}`;
                return (
                  <AccordionItem key={itemKey} item={item} index={i} openKey={openKey} setOpenKey={setOpenKey} itemKey={itemKey} />
                );
              })}
            </section>
          ))
        )}

        {/* Footer contact */}
        <div
          style={{
            marginTop: "2.5rem",
            padding: "1.5rem 1.6rem",
            background: C.greenSoft,
            border: `1px solid ${C.line}`,
            borderRadius: "14px",
          }}
        >
          <div style={{ fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: C.green, marginBottom: "0.7rem" }}>
            Ainda com dúvidas?
          </div>
          <p style={{ margin: "0 0 0.4rem", lineHeight: 1.6, fontSize: "0.95rem", color: C.ink }}>
            Financeiro — <a href="mailto:especializacoes@fundmed.org.br" style={{ color: C.green, fontWeight: 600, textDecoration: "none" }}>especializacoes@fundmed.org.br</a>
          </p>
          <p style={{ margin: 0, lineHeight: 1.6, fontSize: "0.95rem", color: C.ink }}>
            Pós-Graduação DENS — <a href="mailto:posgraduacao@hcpa.edu.br" style={{ color: C.green, fontWeight: 600, textDecoration: "none" }}>posgraduacao@hcpa.edu.br</a> · WhatsApp (51) 3359-6259
          </p>
        </div>
      </div>
    </div>
  );
}